module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-flex"
  }, [_c('drop', [_c('button', {
    staticClass: "hint hint--right btn btn--lg btn--default",
    attrs: {
      "slot": "trigger",
      "data-label": _vm.$t('bulkActions.label')
    },
    slot: "trigger"
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('drop-content', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "c-nav c-nav--menus"
  }, _vm._l((_vm.actions), function(action) {
    return _c('li', {
      key: action,
      staticClass: "c-nav__item"
    }, [_c('a', {
      staticClass: "c-nav__link",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onChangeBulk(action.value, action.module)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(((action.label) + ".label"))))])])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80b8e83a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BulkActions.vue
// module id = 3340
// module chunks = 0